export default __webpack_public_path__ + "static/media/015-no motorcycles.e72e07b7.png";